import { createThemeFromColor } from './custom'

export const theme = createThemeFromColor('#111111', 'dark-black', 'Dark Black')
